<template>
  <div class="feedback-box">
    <a @click="showModal">意见反馈</a>
    <a-modal
        title="意见反馈"
        :visible="visible"
        @ok="onSubmit"
        okText='确定'
        @cancel="handleCancel"
        cancelText="取消"
        class="zcy-modal"
        :confirmLoading="confirmLoading"
        :afterClose="afterClose"
        destroyOnClose
    >
        <a-form @submit="onSubmit" :form="form">
          <a-form-item
            v-bind="formItemLayout"
            label="邮箱"
          >
            <a-input
              v-decorator="config.email"
            />
          </a-form-item>
          <a-form-item
            v-bind="formItemLayout"
            label="手机号"
          >
            <a-input
              v-decorator="config.phone"
            />
          </a-form-item>
          <a-form-item
            v-bind="formItemLayout"
            label="反馈意见"
            class="feedbck-box"
            :validate-status="feedbackStatus"
          >
            <a-textarea
              v-decorator="config.feedback"
              @change="onFeedbackChange"
            />
            <span class="counter"><b>{{ counter }}</b>/{{ feedbackMaxCounter }}</span>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
</template>

<script>
import request from '@/utils/request';
const maxCounter = 200;
export default {
  name: 'suggest-modal',
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  data () {
    return {
      formLayout: 'horizontal',
      config: {
        phone: [
          'phone',
          {
            rules: [
              { required: true, message: '请输入手机号' },
              { pattern: /^1\d{10}$/, message: '请输入正确的11位手机号' }
            ]
          }
        ],
        email: [
          'email',
          {
            rules: [
              {
                required: true, message: '请输入您的邮箱', whitespace: true
              },
              {
                pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i,
                message: '请输入正确的邮箱地址'
              }
            ]
          }
        ],
        feedback: [
          'feedback',
          {
            rules: [
              {
                required: true, message: '请输入您的反馈意见', whitespace: true
              },
              {
                max: maxCounter,
                message: `最多输入${maxCounter}个字符`
              }
            ]
          }
        ]
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      counter: 0,
      feedbackStatus: '',
      feedbackMaxCounter: maxCounter,
      confirmLoading: false,
      visible: false
    };
  },
  methods: {
    onSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          this.submit({
            ...values,
            channel: '采讯'
          });
        } else {
          const feedback = values.feedback;
          if (!feedback || feedback.length === 0 || feedback.length > maxCounter) {
            this.feedbackStatus = 'error';
          } else {
            this.feedbackStatus = '';
          }
        }
      });
    },
    onFeedbackChange (e) {
      const len = e.target.value.length;
      this.counter = len;
      console.log(len);
      if (len > maxCounter || len === 0) {
        this.feedbackStatus = 'error';
      } else {
        this.feedbackStatus = '';
      }
    },
    submit (data) {
      this.confirmLoading = true;
      request('/api/eco/base/saveFeedback', {
        method: 'post',
        data
      }).then(res => {
        if (res.success) {
          this.$message.destroy();
          this.$message.success('提交成功');
          this.visible = false;
        } else {
          this.$message.error(res.message);
        }
        // this.toggleVisible();
        this.confirmLoading = false;
        // this.toggleVisible(() => {
        //   this.confirmLoading = false;
        // })
      }).catch(() => {
        this.confirmLoading = false;
      });
    },
    toggleVisible () {
      this.visible = !this.visible;
    },
    handleCancel () {
      this.visible = false;
    },
    showModal () {
      this.visible = true;
    },
    afterClose () {
      this.counter = 0;
      this.feedbackStatus = '';
    }
  }
};
</script>

<style lang="less">
.zcy-modal {
  width: 640px;
  .ant-modal-title {
    text-align: center;
  }
  .counter {
    position: absolute;
    bottom: 0px;
    right: 10px;
    line-height: 15px;
    color: #999;
    b {
      color: #333;
      font-weight: normal;
    }
    // display: none;
  }
  .anticon-close {
    background: #f0f0f0;
    padding: 4px;
    border-radius: 100%;
    svg {
      color: #939393;
      font-size: 10px;
      transform: scale(0.8)
    }
  }
  .feedbck-box {
    position: relative;
    textarea {
      height: 125px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header/modal.vue